import React from "react";
import { Link, navigate } from "@reach/router";
import { useSelector, useDispatch } from "react-redux";
import { selectSignedIn, signOut } from "reducers/auth";
import SignOutIcon from "assets/Icon_Nav_11.png";

export default function AccountMenuDropdown() {
  const dispatch = useDispatch();

  const handleSignOut = () => {
    dispatch(signOut());
    navigate("/sign-in");
  };

  return (
    <div onClick={handleSignOut} className="AccountMenu__DropdownMenuItem">
      <img className="AccountMenu__DropdownMenuItemIcon" src={SignOutIcon} />
      Sign Out
    </div>
  );
}
